import { ReactNode } from 'react';

import { ClaimListPanelType } from '~/components/Claim/ClaimListPanel/types';
import ActionArrowIcon from '~/core/iconComponents/icons/ActionArrowIcon';
import BulbIcon from '~/core/iconComponents/icons/BulbIcon';
import ChatIcon from '~/core/iconComponents/icons/ChatIcon';
import FlashIcon from '~/core/iconComponents/icons/FlashIcon';
import EmptyState from '~/core/molecules/EmptyState';

export const InsightsEmptyState = (
  <EmptyState
    title="No Insights Yet"
    description="Any insight I’ll have, I’ll share with you here"
    className="pt-0"
    icon={
      <div className="flex h-40 w-40 items-center justify-center rounded-xl bg-pink-100">
        <BulbIcon size={22} className="shrink-0 text-pink-600" />
      </div>
    }
  />
);

export const ActionsEmptyState = (
  <EmptyState
    title="No Actions Yet"
    description="Any actions needed will appear here"
    className="pt-0"
    icon={
      <div className="flex h-40 w-40 items-center justify-center rounded-xl bg-blue-100">
        <FlashIcon size={22} className="shrink-0 text-blue-600" />
      </div>
    }
  />
);

export const ChatsEmptyState = (
  <EmptyState
    title="No Chats Yet"
    description="All your past chats with me will appear here."
    className="pt-0"
    icon={
      <div className="flex h-40 w-40 items-center justify-center rounded-xl bg-blue-100">
        <ChatIcon size={22} className="shrink-0 text-blue-600" />
      </div>
    }
  />
);

export const DocumentsEmptyState = (
  <EmptyState
    title="No Activities Yet"
    description="Activities and Documents will appear here"
    className="pt-0"
    icon={
      <div className="flex h-40 w-40 items-center justify-center rounded-xl bg-purple-100">
        <ActionArrowIcon size={22} className="shrink-0 text-purple-600" />
      </div>
    }
  />
);

export const EMPTY_STATES_BY_TYPE: Record<ClaimListPanelType, ReactNode> = {
  insight: InsightsEmptyState,
  action: ActionsEmptyState,
  chat: ChatsEmptyState,
  document: DocumentsEmptyState,
};
